import { render } from "./TabbarMain.vue?vue&type=template&id=82ad946e&scoped=true"
import script from "./TabbarMain.vue?vue&type=script&lang=js"
export * from "./TabbarMain.vue?vue&type=script&lang=js"

import "./TabbarMain.vue?vue&type=style&index=0&id=82ad946e&scoped=true&lang=css"
import "./TabbarMain.vue?vue&type=style&index=1&id=82ad946e&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82ad946e"]])

export default __exports__